HybridOption = App.loadClass "grower::classes/placement/HybridOption"
PlantingPlanHybrid = App.loadClass "grower::classes/placement/PlantingPlanHybrid"
EncodingUtils = App.loadClass "core::utils/encoding"

# TODO: this needs to be converted to a proper coffeescript class
exports.Field = (field = {}, parent) ->
    self = this

    @getParent = () ->
        return parent

    @handleResponse = (response) ->
        if response.status?.type is 'success'

            hybridsTaffy = parent.spp.taffyObjects.hybrids

            has_refuge_options = false
            for hybrid in response.data.hybrids
                ho = new HybridOption(hybrid, hybridsTaffy)
                self.hybrids.push ho

                # check the refuge requirement
                ho.requires_refuge = (ho.ref_pct > 0)

                # Make sure our hybrid actually has the proper refuges.
                # This should only be the case when repopulating selections
                # from a planting plan
                if ho.id is self.hybrid_selection()?.id
                    self.hybrid_selection(ho)

                if ho.refuge_options.length
                    has_refuge_options = true
                    for ro in ho.refuge_options
                        if ro.id is self.refuge_selection()?.id
                            self.refuge_selection(ro)

            if not has_refuge_options
                self.refuge_selection(null)

            if response.data.low_yield_hybrids.length
                for hybrid in response.data.low_yield_hybrids
                    ho = new HybridOption(hybrid, hybridsTaffy)
                    self.lowYieldHybrids.push ho

                    if ho.id is self.low_yield_hybrid_selection()?.id
                        self.low_yield_hybrid_selection(ho)
            else
                self.low_yield_hybrid_selection(null)

            self.showSpinner(false)
            # self.displayHybrids(true)
            self.showError(false)


        else if response.status?.type is 'error'

            self.showSpinner(false)
            # self.displayHybrids(false)
            self.showError(true)

        # otherwise leave the spinner visible
        # TODO: we should probably add a generic error message to show if the
        # request failed, or perhaps retry it.
        # (Note: showError() is currently just for the validation error)


    @setSurveyDetails = (details) ->
        @left_column = []
        @right_column = []

        if not details?.length
            return

        total_height = 0
        for detail in details
            [key, value] = detail
            total_height += if value instanceof Array then 3 else 1

        # This is where the column-balancing magic happens.

        # Single details will be placed in the right column only once the left
        # column takes up at least half the combined height of the columns.
        # Multiselect details will be moved to the right column more often,
        # such that they may even cause the right column to be taller than the
        # left, which is sometimes preferable (hence the `total_height - 4`).
        # This also enables us to place a multiselect in the right column,
        # while keeping a later single detail in the left column.
        # This results in a generally well-balanced output, with the
        # multiselects mostly in the right column.
        # Please do not change this without consulting me first.
        # -SK

        left_height = 0
        # right_height = 0
        for detail in details
            # create the detail object
            [key, value] = detail
            is_array = value instanceof Array
            if _.isString(value)
                # TODO: make this more robust (but this works for now)
                value = value.replace('<br>', ' ')
            detail = key: key, value: value

            # decide which column to put it in
            if not is_array and left_height < total_height / 2
                @left_column.push detail
                left_height += 1
            else if is_array and left_height < (total_height - 4) / 2
                @left_column.push detail
                left_height += 3
            else
                @right_column.push detail


    @saveSeedSelection = (callback = null) ->

        hybrid          = self.hybrid_selection()
        lowYieldHybrid  = self.low_yield_hybrid_selection()
        refuge          = self.refuge_selection()

        postParams =
            id: parent.spp_id
            result_id: parent.results_id
            field_id: self.id

        if hybrid?          then postParams.hybrid_id           = hybrid.id
        if lowYieldHybrid?  then postParams.low_yield_hybrid_id = lowYieldHybrid.id
        if refuge?          then postParams.refuge_id           = refuge.id

        $.post 'backend/grower/placement/spp/save-seed-selection', postParams, (response) ->
            # handle the request silently
            callback?()


    # TODO: I wonder if this should really go somewhere else
    # TODO: why the frak am I passing in the hybridsTaffy table??
    # TODO: combine this with the setRxPlan method somehow
    @setPlantingPlan = (planting_id, results, hybridsTaffy, selectionsKO, doAJAX) ->
        self.planting_plan_id(planting_id)
        self.rx_plan_id(null)
        self.hidden_planting_plan_id(null)

        hybrid = results[0]
        refuge = results[1]

        # todo: make this less gross
        if hybrid?
            id = parseInt( hybrid.id )
            ho = ( new TAFFY self.hybrids() )( id: id ).first()
            if not ho
                refuge_options = if refuge? then [ refuge ] else []
                ho = new HybridOption(hybrid, hybridsTaffy, false, refuge_options)

            self.hybrid_selection(ho)

            if refuge?
                id = parseInt( refuge.id )
                ro = (new TAFFY ho.refuge_options)( id: id ).first()
                if not ro
                    ro = new HybridOption(refuge, hybridsTaffy, true)
                self.refuge_selection(ro)
            else
                self.refuge_selection(null)
        else
            self.hybrid_selection(null)
            self.refuge_selection(null)

        self.low_yield_hybrid_selection(null)

        self.saveSeedSelection()

        # we also update the taffy objects for the SPP itself so that we can
        # pull up the selections if we leave the last step and then get
        # recommendations again
        sppField = parent.spp.taffyObjects.fields( id: parseInt self.id ).first()
        sppField.planting_plan_id = self.planting_plan_id()

        self.plannedHybrids.removeAll()
        sppField.planting_plan_hybrids = []
        for result in results
            plantingPlanHybrid = new PlantingPlanHybrid(result, planting_id)
            self.plannedHybrids.push plantingPlanHybrid
            sppField.planting_plan_hybrids.push plantingPlanHybrid

        selectionsKO.setPlan self.id, self.plannedHybrids()

        if doAJAX
            postParams =
                id: parent.spp_id
                result_id: parent.results_id
                field_id: self.id
                pp_id: planting_id

            $.post 'backend/grower/placement/spp/set-planting-plan', postParams, (response) ->
                # handle the request silently
                undefined

    @setRxPlan = (rx_id, planting_id, results, hybridsTaffy, selectionsKO, doAJAX) ->
        self.planting_plan_id(null)
        self.rx_plan_id(rx_id)
        self.hidden_planting_plan_id(planting_id)

        if results.length > 0
            hybrid = null
            low_yield_hybrid = null
            refuge = null
            for result in results
                # multi-hybrid scenario
                if result.is_high_yield
                    hybrid = result
                if result.is_low_yield
                    low_yield_hybrid = result
                # refuge
                if result.is_refuge
                    refuge = result

            if not hybrid?
                for result in results
                    # single-hybrid scenario
                    if not result.is_high_yield and not result.is_refuge
                        hybrid = result
                        break

            if hybrid?
                id = parseInt( hybrid.id )
                ho = ( new TAFFY self.hybrids() )( id: id ).first()
                if not ho # don't use ho? here
                    refuge_options = if refuge? then [ refuge ] else []
                    ho = new HybridOption(hybrid, hybridsTaffy, false, refuge_options)

                self.hybrid_selection(ho)

                if low_yield_hybrid?
                    id = parseInt( low_yield_hybrid.id )
                    lyho = ( new TAFFY self.hybrids() )( id: id ).first()
                    if not lyho # don't use lyho? here
                        lyho = new HybridOption(low_yield_hybrid, hybridsTaffy, false, [])

                    self.low_yield_hybrid_selection(lyho)
                else
                    self.low_yield_hybrid_selection(null)

                if refuge?
                    id = parseInt( refuge.id )
                    ro = ( new TAFFY ho.refuge_options )( id: id ).first()
                    if not ro # don't use ro? here
                        ro = new HybridOption(refuge, hybridsTaffy, true)

                    self.refuge_selection(ro)
                else
                    self.refuge_selection(null)

            else
                self.hybrid_selection(null)
                self.low_yield_hybrid_selection(null)
                self.refuge_selection(null)

        else
            self.hybrid_selection(null)
            self.low_yield_hybrid_selection(null)
            self.refuge_selection(null)

        self.saveSeedSelection()

        # we also update the taffy objects for the SPP itself so that we can
        # pull up the selections if we leave the last step and then get
        # recommendations again
        sppField = parent.spp.taffyObjects.fields( id: parseInt self.id ).first()
        sppField.rx_plan_id = self.rx_plan_id()
        sppField.hidden_planting_plan_id = self.hidden_planting_plan_id()

        self.plannedHybrids.removeAll()
        sppField.rx_plan_hybrids = []
        for result in results
            plantingPlanHybrid = new PlantingPlanHybrid(result, planting_id)
            self.plannedHybrids.push plantingPlanHybrid
            sppField.rx_plan_hybrids.push plantingPlanHybrid

        selectionsKO.setPlan self.id, self.plannedHybrids()

        if doAJAX
            postParams =
                id: parent.spp_id
                result_id: parent.results_id
                field_id: self.id
                rx_id: rx_id

            $.post 'backend/grower/placement/spp/set-rx-plan', postParams, (response) ->
                # handle the request silently
                undefined


    # Fields dropdown functions
    @getOptionClass = () ->
        if self.planting_plan_id()? or self.rx_plan_id()?
            return 'placement-finished-fields'


    # Hybrid interaction functions

    # TODO: Ugggggghhhh! Fix all the copy/paste grossness! :(
    # maybe we could make a ResultSet class or something?

    @getNextHybrids = (checkOnly = false) ->
        arr = self.hybrids()
        ind = self.hybridSliceIndex
        return self._increment arr, ind, checkOnly

    @getPrevHybrids = (checkOnly = false) ->
        arr = self.hybrids()
        ind = self.hybridSliceIndex
        return self._decrement arr, ind, checkOnly

    @selectHybrid = (hybrid) ->
        if hybrid.id is self.hybrid_selection()?.id
            self.hybrid_selection null
        else
            self.hybrid_selection hybrid

        self.refuge_selection null
        self.refugeSliceIndex 0

        self.saveSeedSelection()


    @getNextLowYieldHybrids = (checkOnly = false) ->
        arr = self.lowYieldHybrids()
        ind = self.lowYieldHybridSliceIndex
        return self._increment arr, ind, checkOnly

    @getPrevLowYieldHybrids = (checkOnly = false) ->
        arr = self.lowYieldHybrids()
        ind = self.lowYieldHybridSliceIndex
        return self._decrement arr, ind, checkOnly

    @selectLowYieldHybrid = (hybrid) ->
        if hybrid.id is self.low_yield_hybrid_selection()?.id
            self.low_yield_hybrid_selection null
        else
            self.low_yield_hybrid_selection hybrid

        self.saveSeedSelection()


    @getNextRefuges = (checkOnly = false) ->
        hybrid = self.hybrid_selection()
        arr = hybrid?.refuge_options?()
        ind = self.refugeSliceIndex
        return self._increment arr, ind, checkOnly

    @getPrevRefuges = (checkOnly = false) ->
        hybrid = self.hybrid_selection()
        arr = hybrid?.refuge_options?()
        ind = self.refugeSliceIndex
        return self._decrement arr, ind, checkOnly

    @selectRefuge = (refuge) ->
        if refuge.id is self.refuge_selection()?.id
            self.refuge_selection null
        else
            self.refuge_selection refuge

        self.saveSeedSelection()


    # Helper functions
    @_increment = (arr, ind, checkOnly) ->
        return self._set arr, ind, ind() + self.numResults, checkOnly

    @_decrement = (arr, ind, checkOnly) ->
        return self._set arr, ind, ind() - self.numResults, checkOnly

    @_set = (arr, ind, newInd, checkOnly) ->
        rawNewInd = newInd

        # check the bounds
        newInd = Math.max(Math.min(newInd, (arr?.length ? 0) - self.numResults), 0)
        debugLog(arr?.length + ', ' + ind() + ', ' + rawNewInd + ', ' + newInd + ', ' + checkOnly)

        # do a strict comparison for checkOnly because knockout likes to pass
        # objects to your functions, which isn't always obvious
        oldInd = ind()
        if checkOnly isnt true
            ind(newInd)
        return oldInd is newInd


    # field
    @field_name         = EncodingUtils.htmlDecode field.display_name
    @id                 = field.id ? null
    @fsr_id             = field.fsr_id ? null
    @field_num          = null

    # survey details
    @left_column = []
    @right_column = []

    # recommendations

    @numResults         = parent.numResults

    @hybrids            = ko.observableArray []
    @lowYieldHybrids    = ko.observableArray []

    @showSpinner        = ko.observable true
    @showError          = ko.observable false


    # hybrids

    @hybridSliceIndex   = ko.observable 0

    @visibleHybrids     = ko.computed () ->
        sliceIndex = self.hybridSliceIndex()
        return self.hybrids.slice(sliceIndex, sliceIndex + self.numResults) ? []

    # This is quite possibly the most beautiful mixture of technologies I've
    # ever written. An aromatic blend of elegant coffeescript syntax, powerful
    # knockout data interactions, exotic coffeescript operators, some hints of
    # taffy, and a bit of native javascript lending its familiarity, this is
    # truly a celebration of diversity!
    # -SK
    @hybrid_selection   = ko.observable null
    @hybrid_selection.subscribe (sel) ->
        # anytime @hybrid_selection changes, make sure it will appear in
        # @visibleHybrids, if possible
        hid = parseInt sel?.id
        if hid
            hids = (new TAFFY self.hybrids())().select 'id'
            vhids = (new TAFFY self.visibleHybrids())().select 'id'
            if hid in hids and hid not in vhids
                i = hids.indexOf hid
                self.hybridSliceIndex Math.floor(i / self.numResults) * self.numResults


    # low yield hybrids

    @lowYieldHybridSliceIndex   = ko.observable 0

    @visibleLowYieldHybrids     = ko.computed () ->
        sliceIndex = self.lowYieldHybridSliceIndex()
        return self.lowYieldHybrids.slice(sliceIndex, sliceIndex + self.numResults) ? []

    @low_yield_hybrid_selection   = ko.observable null
    @low_yield_hybrid_selection.subscribe (sel) ->
        # anytime @hybrid_selection changes, make sure it will appear in
        # @visibleHybrids, if possible
        hid = parseInt sel?.id
        if hid
            hids = (new TAFFY self.lowYieldHybrids())().select 'id'
            vhids = (new TAFFY self.visibleLowYieldHybrids())().select 'id'
            if hid in hids and hid not in vhids
                i = hids.indexOf hid
                self.lowYieldHybridSliceIndex Math.floor(i / self.numResults) * self.numResults


    # refuges

    @refugeSliceIndex   = ko.observable 0

    @visibleRefuges     = ko.computed () ->
        hybrid = self.hybrid_selection()
        if hybrid? and hybrid not in self.visibleHybrids()
            return []

        sliceIndex = self.refugeSliceIndex()
        return hybrid?.refuge_options?.slice(sliceIndex, sliceIndex + self.numResults) ? []

    @refuge_selection   = ko.observable null
    @refuge_selection.subscribe (sel) ->
        # anytime @refuge_selection changes, make sure it will appear in
        # @visibleRefuges, if possible
        hybrid = self.hybrid_selection()
        if not hybrid? or (hybrid? and hybrid not in self.visibleHybrids())
            return

        hid = parseInt sel?.id
        if hid
            hids = (new TAFFY hybrid.refuge_options)().select 'id'
            vhids = (new TAFFY self.visibleRefuges())().select 'id'
            if hid in hids and hid not in vhids
                i = hids.indexOf hid
                self.refugeSliceIndex Math.floor(i / self.numResults) * self.numResults


    # plans
    @planting_plan_id           = ko.observable null
    @rx_plan_id                 = ko.observable null
    @hidden_planting_plan_id    = ko.observable null

    @plannedHybrids = ko.observableArray []

    # @_init()

    return this
